import { VisualizationCard } from "~/modules/visualization/components/VisualizationCard";
import { BarChartConfig } from "~/modules/charts/types";
import { BarChartProvider } from "./BarChartProvider";

// // // //

/**
 * BarChartRenderer
 * Renders a bar chart with an optional group-by control.
 */
export function BarChartRenderer(props: {
    title: string;
    description: string;
    config: BarChartConfig;
}) {
    const { title, description, config } = props;

    return (
        <>
            <BarChartProvider
                title={title}
                description={description}
                config={config}
                height={400}
            >
                {({
                    title,
                    description,
                    isLoading,
                    isEmpty,
                    chartEl,
                    emptyEl,
                    loadingEl,
                    customControls,
                }) => (
                    <VisualizationCard
                        title={title}
                        subtitle={description}
                        watermark="center-50pct"
                        showTimestamp={false}
                        cardClassName="@container"
                        wrapperClassNameOverride=""
                        colSpans={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                            xxl: 12,
                        }}
                        customControls={customControls}
                    >
                        {isLoading && <>{loadingEl}</>}
                        {!isLoading && isEmpty && <>{emptyEl}</>}
                        {!isLoading && !isEmpty && <>{chartEl}</>}
                    </VisualizationCard>
                )}
            </BarChartProvider>
        </>
    );
}
